import { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Input, Form, Button, Alert,
} from 'reactstrap';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TransferenceStatus, getTransferenceStatusFromId } from '@autofact-lib/operation-lib-model-notary-platform';
import BackendApiService from '../../services/BackendApiService';
import AssignMassiveRepertoryModal from './AssignMassiveRepertoryModal';
import {
  EXTERNAL_PROCESS,
  resolveExternalRepertoryOutcome,
  resolveStepFromTokenResponse,
} from '../../helpers/externalRepertoryProcess';
import { setMapEntry } from '../../helpers/prevStateUpdates';

class AssignMassiveRepertoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferencesList: [],
      transferencesSelected: {},
      transferencesMapAssign: {},
      firstRepertoryId: null,
      firstRepertoryValue: 0,
      assignInProgress: false,
      fails: {},
      recordCount: 0,
      selectedRecordCount: 0,
      displayMessage: '',
      redirect: false,
      externalProcessActive: false,
      step: '',
    };

    this.transferenceSelected = this.transferenceSelected.bind(this);
    this.assignProgresStatus = this.assignProgresStatus.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  componentDidMount() {
    this.fetchData();
    this.setState({ step: 'MENU' });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.transferencesList !== this.state.transferencesList && this.props.automaticAssignment) {
      this.handlerSelectedAll();
    }
    if (prevState.selectedRecordCount !== this.state.selectedRecordCount && this.props.automaticAssignment) {
      this.setState({ externalProcessActive: true, step: EXTERNAL_PROCESS.MENU });
    }
  }

  onDismiss() {
    this.setState({ isMessageVisible: false });
  }

  showSuccesMessage(message) {
    this.setState({
      message: {
        success: true,
        text: message,
      },
      isMessageVisible: true,
    });
  }

  showErrorMessage(message) {
    this.setState({
      message: {
        success: false,
        text: message,
      },
      isMessageVisible: true,
    });
  }

  fetchData = async () => {
    const params = {
      where: JSON.stringify({
        STATUS: TransferenceStatus.REPERTORY.id,
      }),
      per_page: -1,
    };
    const transferencesList = await BackendApiService.getTransferenceList(params);
    const { data } = transferencesList;
    const firstElement = data[0] || {};
    this.setState({
      transferencesList: data,
      firstRepertoryId: firstElement.codigo || null,
      recordCount: transferencesList.extra.recordsTotal,
    });
  };

  transferenceSelected(e, item) {
    // Read the event up front: React pools synthetic events, so e.target is no
    // longer safe to touch once the updater runs on the flushed batch.
    const { checked, value } = e.target;
    // The counter is derived inside the same updater as the map it counts, so
    // the two can never disagree on a batch that carries several selections.
    this.setState((prevState) => {
      const stateToChange = { ...prevState.transferencesSelected };
      if (checked) {
        stateToChange[value] = item;
      } else {
        delete stateToChange[value];
      }
      return {
        transferencesSelected: stateToChange,
        selectedRecordCount: Object.keys(stateToChange).length,
      };
    });
  }

  assignProgresStatus(fails) {
    this.setState({ fails });
  }

  async sendExternalRepertoriesRequest() {
    const transfers = this.state.transferencesList.map((item) => item.idtransferencia);
    const response = await BackendApiService.SendExternalRepertoriesRequest(transfers);
    return response;
  }

  async getExternalRepertoryRequest() {
    const transferObject = {};
    this.state.transferencesList.forEach((item) => transferObject[item.patente] = item.codigo);
    return BackendApiService.GetExternalRepertoryRequest(transferObject);
  }

  AssignExternalRepertories = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    this.setState({ externalProcessActive: true, step: EXTERNAL_PROCESS.LOADING });
    const repertoriesRequestResponse = await this.getExternalRepertoryRequest();
    const outcome = resolveExternalRepertoryOutcome(repertoriesRequestResponse);
    if (outcome.needsTokenRequest) {
      const tokenResponse = await this.sendExternalRepertoriesRequest();
      this.setState({ step: resolveStepFromTokenResponse(tokenResponse) });
      return;
    }
    this.setState({ step: outcome.step });
  };

  handlerAssignRepertory = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    const buildTransferencesParams = [];
    for (const key in this.state.transferencesSelected) {
      buildTransferencesParams.push({
        transferenceCode: `${key}`,
        repertoryNumber: this.state.transferencesMapAssign[key],
      });
    }
    this.setState({ assignInProgress: true });

    const assignMasiveResponse = await BackendApiService.assignMasiveRepertory(buildTransferencesParams, this.assignProgresStatus);
    if (!assignMasiveResponse) {
      this.showErrorMessage('Ocurrio un error asignando los repertorios');
    } else if (assignMasiveResponse.countFail > 0) {
      this.showSuccesMessage(`Se asignaron ${assignMasiveResponse.countOK} y fallaron las siguientes transferencias ${assignMasiveResponse.fails.join(', ')}`);
    } else {
      this.showSuccesMessage(`Se asignaron ${assignMasiveResponse.countOK} repertorios`);
      this.setState({ redirect: true });
    }
    this.setState({
      assignInProgress: false, fails: {}, transferencesSelected: {}, transferencesMapAssign: {},
    });
    this.fetchData();
  };

  handlerClearSelected = (e) => {
    e.preventDefault();
    console.log('Borrando seleccionados ');
    this.setState({ transferencesSelected: {} });
  };

  handlerAutocompleteRepertories = (e) => {
    e.preventDefault();
    console.log('Asignando repertorios seleccionados');
    let pos = 0;
    const transferencesMapAssign = {
      [this.state.firstRepertoryId]: this.state.firstRepertoryValue,
    };
    const firstValue = Number.parseInt(this.state.firstRepertoryValue);
    if (Number.isNaN(firstValue)) {
      this.setState({
        displayMessage: {
          message: 'No es un número de repertorio válido',
          type: 'error',
        },
      });
    } else {
      this.state.transferencesList.forEach((transference) => {
        const id = transference.codigo;
        if (id !== this.state.firstRepertoryId && Object.prototype.hasOwnProperty.call(this.state.transferencesSelected, id)) {
          pos++;
          transferencesMapAssign[id] = firstValue + pos;
        }
      });
    }
    this.setState({ transferencesMapAssign });
  };

  updateSelectedCounter = (selected) => {
    let selectedRecordCount = 0;
    for (const key in selected) {
      if (Object.prototype.hasOwnProperty.call(selected, key)) {
        ++selectedRecordCount;
      }
    }
    this.setState({ selectedRecordCount });
  };

  handlerSelectedAll = (e = { target: {} }) => {
    console.log('Seleccionando todos');
    const transferencesSelected = {};
    if (e.target.checked || this.props.automaticAssignment) {
      this.state.transferencesList.forEach((transfer) => {
        transferencesSelected[transfer.codigo] = transfer;
      });
    }
    this.updateSelectedCounter(transferencesSelected);
    this.setState({ transferencesSelected });
  };

  handlerRepertoryChange = (id, e) => {
    // Read the event up front: React pools synthetic events, so e.target is no
    // longer safe to touch once the updater runs on the flushed batch.
    const { value } = e.target;
    this.setState((prevState) => ({
      transferencesMapAssign: setMapEntry(prevState.transferencesMapAssign, id, value),
      firstRepertoryValue: id === prevState.firstRepertoryId
        ? value
        : prevState.firstRepertoryValue,
    }));
  };

  modalProcessButton = () => (
    <Button
      className="btn btn-sm  btn-primary-darker"
      onClick={() => this.setState({ externalProcessActive: false, redirect: true })}
    >
      Aceptar
    </Button>
  );

  modalMenuButtons = () => (
    <>
      <Button
        className="btn btn-sm  btn-primary-darker"
        onClick={this.AssignExternalRepertories}
      >
        Aceptar
      </Button>
      <Button
        className="btn btn-sm  btn-primary"
        onClick={() => this.setState({ externalProcessActive: false, redirect: true })}
      >
        cancelar
      </Button>
    </>
  );

  renderTransferencesList() {
    return this.state.transferencesList.map((transference, index) => {
      let estado = getTransferenceStatusFromId(transference.estado);
      if (estado && estado.label) {
        estado = estado.label;
      } else {
        estado = transference.estado;
      }
      let resultado = '';
      if (this.state.fails[transference.codigo] === -1) {
        resultado = <FontAwesomeIcon icon="spinner" className="icon" spin />;
      } else if (this.state.fails[transference.codigo] === 0) {
        resultado = <FontAwesomeIcon icon="times" className="icon" />;
      } else if (this.state.fails[transference.codigo] === 1) {
        resultado = <FontAwesomeIcon icon="check" className="icon" />;
      }
      const selected = Object.prototype.hasOwnProperty.call(this.state.transferencesSelected, transference.codigo);
      const background = index % 2 === 0 ? 'background' : '';
      const marked = selected ? 'background-selected' : '';
      return (
        <Row key={transference.codigo} className={`data-row field-row ml-0 ${background} ${marked}`}>
          <Col sm={1}>
            <Input
              type="checkbox"
              className="massive-checkbox form-control-sm"
              checked={selected}
              value={transference.codigo}
              disabled={this.props.automaticAssignment}
              onChange={(e) => this.transferenceSelected(e, transference)}
            />
          </Col>
          <Col sm={2}>
            <span className="bold">{transference.patente}</span>
          </Col>
          <Col sm={2}>
            <span className="transference-status transference-status--1">{estado}</span>
          </Col>

          <Col sm={5}>
            <Row>
              <Col sm={6}>
                <Input
                  type="number"
                  name={`transference-repertory-${transference.codigo}`}
                  className="form-control-sm"
                  disabled={!selected || this.props.automaticAssignment}
                  value={this.state.transferencesMapAssign[transference.codigo] || ''}
                  onChange={(e) => this.handlerRepertoryChange(transference.codigo, e)}
                />
              </Col>
              {this.state.assignInProgress && (
              <Col sm={2}>
                {resultado}
              </Col>
              )}
              {index === 0
                        && (
                        <Col
                          sm={4}
                        >
                          <Button
                            className="btn btn-sm  btn-primary-darker"
                            onClick={this.handlerAutocompleteRepertories}
                            disabled={this.props.automaticAssignment}
                          >
                            Completar
                          </Button>
                        </Col>
                        )}
            </Row>
          </Col>
        </Row>
      );
    });
  }

  render() {
    let message = null;
    if (this.state.isMessageVisible) {
      message = (
        <Alert
          className="mt-2"
          color={this.state.message.success ? 'success' : 'danger'}
          isOpen={this.state.isMessageVisible}
          toggle={this.onDismiss}
        >
          {this.state.message.text}
        </Alert>
      );
    }
    if (this.state.redirect) {
      return (
        <Redirect to={{
          pathname: '/transferencias',
          state: { tab: 'forSign' },
        }}
        />
      );
    }
    const transferencesMap = this.renderTransferencesList();
    console.log(this.props.automaticAssignment);
    return (
      <div>
        <div>
          {' '}
          Asigne el
          <strong>primer número de repertorio</strong>
          {' '}
          para completar automáticamente los
          siguientes de manera consecutiva.
        </div>
        {message}
        <div className="bold">
          Cantidad de contratos:
          {this.state.recordCount}
        </div>
        <Form className="massive-view assign-massive-repertory-form">
          <Row className="field-headers field-row ml-0">
            <Col sm={1}>
              <div className="massive-checkbox">
                <Input
                  type="checkbox"
                  className="form-control-sm"
                  checked={this.state.transferencesList.length === Object.keys(this.state.transferencesSelected).length}
                  onChange={this.handlerSelectedAll}
                  disabled={this.props.automaticAssignment}
                />
                {this.state.selectedRecordCount > 0
                  ? (
                    <div className="indicator">
                      <span className="indicator-number">
                        {this.state.selectedRecordCount}
                      </span>
                    </div>
                  )
                  : ''}
              </div>
            </Col>
            <Col sm={2}>
              <span className="bold">Patente</span>
            </Col>
            <Col sm={2}>
              <span className="bold">Estado</span>
            </Col>
            <Col sm={5}>
              <span className="bold">Repertorio</span>
            </Col>
          </Row>
          {transferencesMap}
          <Row className="botton-row">
            <Col sm={3}>
              <Button
                className="btn btn-sm btn-primary form-check-input mt-0"
                onClick={this.handlerClearSelected}
                disabled={this.state.assignInProgress || this.props.automaticAssignment}
              >
                Borrar seleccionados
              </Button>
            </Col>
            <Col sm={9} className="text-right">
              {
                                this.state.assignInProgress
                                  ? <span className="btn btn-sm btn-primary mr-2 disabled">Cancelar</span>
                                  : (
                                    <Link
                                      className="btn btn-sm btn-primary mr-2"
                                      to="/transferencias"
                                    >
                                      Cancelar
                                    </Link>
                                  )
                            }
              {this.props.automaticAssignment
                ? (
                  <Button
                    className="btn btn-sm  btn-primary-darker"
                    onClick={this.AssignExternalRepertories}
                    disabled={this.state.externalProcessActive}
                  >
                    Aplicar
                  </Button>
                )
                : (
                  <Button
                    className="btn btn-sm  btn-primary-darker"
                    onClick={this.handlerAssignRepertory}
                    disabled={this.state.assignInProgress}
                  >
                    Aplicar
                  </Button>
                )}
              {this.state.assignInProgress && <span className="text-info ml-2 font-weight-bold">Espere mientras se asignan los repertorios</span>}
            </Col>
          </Row>
        </Form>
        <AssignMassiveRepertoryModal
          open={this.state.externalProcessActive}
          title="Proceso externo de solicitud de repertorio"
          process={this.state.step}
          okButton={this.modalProcessButton()}
          menu={this.modalMenuButtons()}
        />
      </div>
    );
  }
}

AssignMassiveRepertoryForm.propTypes = {
  automaticAssignment: PropTypes.bool,
};

export default withRouter(AssignMassiveRepertoryForm);
